import { reducerWithInitialState } from "typescript-fsa-reducers";
import { togglePolling } from "./actions";

const initialState = true;

export default reducerWithInitialState<Readonly<boolean>>(initialState).case(
  togglePolling,
  (state, value) => {
    return value;
  }
);



// WEBPACK FOOTER //
// ./src/polling/reducer.ts